import { Routes, Route, Navigate } from "react-router-dom";

/* Auth */
import Login from "./pages/Login/Login";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import ProtectedRoute from "./components/ProtectedRoute";

/* Layout */
import SharedLayout from "./components/sharedLayout/SharedLayout";
import Home from "./pages/Home/Home";

/* Admin Dashboard */
import AdminDashboard from "./pages/AdminDashboard/AdminDashboard";
import SupplierCandidateList from "./components/ListOfOpenJobs/SupplierCandidates"; // Was commented as AdminAccordion, using SupplierCandidateList as per existing code
import ViewFile from "./components/ListOfOpenJobs/ViewFile";

/* Supplier Management */
import SupplierManagement from "./pages/SupplierManagement/SupplierManagement";
import AddSupplier from "./components/SupplierManagement/AddSupplier";
import EditSupplier from "./components/SupplierManagement/EditSupplier";
import ViewSupplier from "./components/SupplierManagement/ViewSupplier";

/* Job Management */
import JobManagement from "./pages/JobManagement/JobManagement";
import AddJob from "./components/JobManagement/AddJob";
import EditJob from "./components/JobManagement/EditJob";
import JobDescriptionByCode from "./components/JobManagement/JobDescriptionByCode";

/* Skill Management */
import SkillManagement from "./pages/SkillManagement/SkillManagement";
import AddSkill from "./components/SkillMangement/AddSkill";
import EditSkill from "./components/SkillMangement/EditSkill";

/* CV Search */
import AiCvSearchView from "./components/CVSearch/AiCvSearchView";
import CvSearchConfigView from "./components/CVSearch/CvSearchConfigView";
/* Client Management */
import ClientMangComp from "./components/Clients/Client";
import AddClient from "./components/Clients/AddClient";
import EditClient from "./components/Clients/EditClient";
import ClientContacts from "./components/Clients/ClientContacts";

/* Interview Tracking */
import InterviewTrack from "./components/InterviewListing/InterviewTrack";

/* Supplier Dashboard */
import SupplierDashboard from "./pages/SupplierDashboard/SupplierDashboard";

/* Candidate Management */
import CandidateManagement from "./pages/CandidateMange/CandidateMange";
import AddCandidate from "./components/CandidateManagement/AddCandidate";
import EditCandidate from "./components/CandidateManagement/EditCandidate";
import ViewCandidate from "./components/CandidateManagement/ViewCandidate";

/* Profile */
import { Profile } from "./uicomponents/Profile";

/* Support */
import Support from "./pages/Support/Support";

/* Analytics */
import AnalyticsDashboard from "./pages/AnalyticsDashboard/AnalyticsDashboard";

/* Offer Management */
import OfferManagement from "./pages/OfferManagement/OfferManagement";
import PublicCandidatePortal from "./pages/OfferManagement/PublicCandidatePortal";

/* Settings */
import Settings from "./pages/Settings/Settings";
import AuditLogs from "./pages/Settings/AuditLogs";
import JobDocumentConfig from "./pages/Settings/JobDocumentConfig";

/* Pipeline Config */
import PipelineConfig from "./pages/PipelineConfig/PipelineConfig";
import CandidateInterviewSelection from "./pages/CandidateInterviewSelection/CandidateInterviewSelection";
import CandidateInterviewSuccess from "./pages/CandidateInterviewSelection/CandidateInterviewSuccess";

/* Headcount & Requisitions */
import HeadcountRequisition from "./components/Headcount/HeadcountRequisition";

const AppRoutes = () => {
    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/resetpassword/:key" element={<ResetPassword />} />
            <Route path="/interview/select/:token" element={<CandidateInterviewSelection />} />
            <Route path="/interview/success" element={<CandidateInterviewSuccess />} />
            <Route path="/offer/:action/:token" element={<PublicCandidatePortal />} />

            {/* Protected Routes Wrapper */}
            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <SharedLayout />
                    </ProtectedRoute>
                }
            >
                {/* Dashboard / Home */}
                <Route path="/" element={<Home />} />
                <Route path="/admindashboard" element={<AdminDashboard />} />

                {/* Admin Dashboard Sub-routes */}
                <Route
                    path="/admindashboard/adminAccordion"
                    // element={<AdminAccordion />}
                    element={<SupplierCandidateList />}
                />
                <Route path="/admindashboard/viewFile" element={<ViewFile />} />

                {/* Supplier Admin */}
                <Route path="/suppliermanagement" element={<SupplierManagement />} />
                <Route
                    path="/suppliermanagement/addSupplier"
                    element={<AddSupplier />}
                />
                <Route
                    path="/suppliermanagement/editSupplier"
                    element={<EditSupplier />}
                />
                <Route
                    path="/suppliermanagement/ViewSupplier"
                    element={<ViewSupplier />}
                />

                {/* Jobs */}
                <Route path="/jobs" element={<JobManagement />} />
                <Route path="/jobs/addJob" element={<AddJob />} />
                <Route path="/jobs/editJob" element={<EditJob />} />
                {/* Deep link: open one job's description directly by job_code,
                    e.g. for external systems (webhook recipients) redirecting
                    an already-authenticated user straight to a specific job. */}
                <Route path="/jobs/code/:jobCode" element={<JobDescriptionByCode />} />

                {/* Skills */}
                <Route path="/skills" element={<SkillManagement />} />
                <Route path="/skills/addSkill" element={<AddSkill />} />
                <Route path="/skills/editSkill" element={<EditSkill />} />

                {/* CV Search */}
                <Route path="/cv_search" element={<AiCvSearchView />} />
                <Route path="/cv_search_config" element={<CvSearchConfigView />} />
                {/* Deprecated: /cv_search/resumeList replaced by AiCvSearchView — redirect to canonical route */}
                <Route path="/cv_search/resumeList" element={<Navigate replace to="/cv_search" />} />
                {/* Clients */}
                <Route path="/clients" element={<ClientMangComp />} />
                <Route path="/clients/addClient" element={<AddClient />} />
                <Route path="/clients/editClient" element={<EditClient />} />
                <Route
                    path="/clients/contacts"
                    element={<ClientContacts />}
                />

                {/* InterviewTrack */}
                <Route path="/interview_info" element={<InterviewTrack />} />

                {/* Supplier */}
                <Route path="/supplierdashboard" element={<SupplierDashboard />} />

                {/* Candidate */}
                <Route path="/candidate_data" element={<CandidateManagement />} />
                <Route
                    path="/candidate_data/addCandidate"
                    element={<AddCandidate />}
                />
                <Route
                    path="/candidate_data/editcandidate"
                    element={<EditCandidate />}
                />
                <Route
                    path="/candidate_data/Viewcandidate"
                    element={<ViewCandidate />}
                />
                <Route path="/candidate_data/viewFile" element={<ViewFile />} />

                {/* Profile */}
                <Route path="/profile" element={<Profile />} />

                {/* Support */}
                <Route path="/support" element={<Support />} />

                {/* Analytics */}
                <Route path="/analytics" element={<AnalyticsDashboard />} />

                {/* Offer Management */}
                <Route path="/offermanagement" element={<OfferManagement />} />

                {/* Settings */}
                <Route path="/settings" element={<Settings />}>
                    <Route index element={<Navigate replace to="/settings/audit-logs" />} />
                    <Route path="audit-logs" element={<AuditLogs />} />
                    <Route path="job-document-config" element={<JobDocumentConfig />} />
                </Route>

                {/* Pipeline Config */}
                <Route path="/pipeline-config" element={<PipelineConfig />} />

                {/* Headcount & Requisition Management */}
                <Route path="/requisitions" element={<HeadcountRequisition />} />
            </Route>
        </Routes>
    );
};

export default AppRoutes;
